const initNode = (node) => {
  node.classList.add('lottie-autoplay_initialized');
  node.addEventListener('mouseover', () => { node.play() });
  node.addEventListener('mouseleave', () => { node.stop() });
}

const initAll = () => {
  const nodes = document.querySelectorAll('.lottie-autoplay:not(.lottie-autoplay_initialized)');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
